<template>
  <div>    
    <div class="columns">
      <div class="column is-4" v-if="!queries">
       <p class="subtitle">Bookings</p>
       <p class="title" v-if="isUsersLoading">Loading bookings...</p>
        <!-- <p v-if="!isUsersLoading && !queries">Please select a category to view its queries.</p> -->
      </div>
     
      <div class="column   queries-container" v-if="queries">
        <div class="columns ">
          <div class="column is-2">
            <p class="subtitle" v-if="queries">Bookings <strong>({{queries.length}}) </strong></p>
          </div>
          <div class="column is-10">
            <b-field expanded>
              <b-input v-model="searchName"  type="search" icon="search" :disabled="!queries || !queries.length" placeholder="Search Queries "></b-input>
            </b-field>
          </div>
        <!--   <div class="column is-3">
            <a class="button is-primary full-width-button" disabled @click="openModal" >
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
              <span>Add</span>
            </a>
          </div> -->
        </div>

  <p class="title" v-if="isUsersLoading">Loading queries...</p>  
  <div class="box">
  <!-- <table class="table is-fullwidth is-responsive" :data="qury"  >
  <thead>
    <tr>
      <th>No.</th>
      <th>Query No.</th>
      <th>Query Date</th>
      <th>Agent</th>
      <th>Travel Date</th>
      <th>Nights</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody >
    <tr  v-for="(qury, index) in filterBy(queries, searchName)" :key="qury.docId" >
      <td>{{index + 1}}</td>
      <td data-label="Agency Code1"><strong>{{qury.queryNo}}</strong></td>
      <td data-label="Agency Code1">{{moment(qury.createdAt).format('Do MMM YYYY')}}</td>
      <td data-label="Agency Code1">{{qury.createdBy}}</td>
      <td data-label="Agency Code1">{{moment(qury.queryDate).format('Do MMM YYYY')}}</td>
      <td data-label="Agency Code1">{{qury.nights}}</td>
      <td>
          <span class="tag is-dark" v-if="qury.status == 'query'">Query</span>
          <span class="tag is-success" v-if="qury.status == 'confirmed'">Confirmed</span>
          <span class="tag is-warning" v-if="qury.status == 'waitingForConfirmation'">Waiting For Confirmation</span>
          <span class="tag is-danger" v-if="qury.status == 'cancelled'">Cancelled</span>
          <span class="tag is-danger" v-if="qury.status == 'waitingForCancellation'">Waiting For Cancellation</span>
          <span class="tag is-danger" v-if="qury.status == 'rejected'">Rejected</span>
      </td>
      <td>
          <i class="fa fa-eye icon" @click="openModal(qury)" title="Edit qury" ></i>
          <i class="fa fa-print icon" @click="openModal(qury)" title="Edit qury" ></i>
      </td>
      </tr>
      </tbody> 
      </table> --> 
       <b-table
            :data="queries"
            :current-page.sync="currentPage"
            :per-page="perPage"
            :paginated="isPaginated"
            :mobile-cards="hasMobileCards"
            :default-sort-direction="defaultSortDirection"
             default-sort="qury.queryNo"
       >
            <template slot-scope="props">
               
               
                <b-table-column field="queryNo" label="Query No." sortable >
                   <strong> {{ props.row.queryNo }} </strong>
                </b-table-column>
                <b-table-column field="queryDate" label="Query Date" sortable  >
                      {{moment(props.row.queryDate).format('Do MMM YYYY')}}
                </b-table-column>
                    <b-table-column field="createdBy" label="Agent" sortable >
                    {{ props.row.createdBy }}
                </b-table-column>
                    <b-table-column field="travelDate" label="Travel Date" sortable >
                   {{moment(props.row.travelDate).format('Do MMM YYYY')}}
                </b-table-column>
                    <b-table-column field="nights" label="Nights" sortable >
                    {{ props.row.nights }}
                </b-table-column>
          <b-table-column field="status" label="Status" sortable >
          <span class="tag is-dark" v-if="props.row.status == 'query'">Query</span>
          <span class="tag is-success" v-if="props.row.status == 'confirmed'">Confirmed</span>
          <span class="tag is-warning" v-if="props.row.status == 'waitingForConfirmation'">Waiting For Confirmation</span>
          <span class="tag is-danger" v-if="props.row.status == 'cancelled'">Cancelled</span>
          <span class="tag is-danger" v-if="props.row.status == 'waitingForCancellation'">Waiting For Cancellation</span>
          <span class="tag is-danger" v-if="props.row.status == 'rejected'">Rejected</span>
                </b-table-column>
                <b-table-column field="action" label="Actions">
          <i class="fa fa-eye icon" @click="openModal(props.row)" title="Edit qury" ></i>
          <i class="fa fa-print icon" @click="openModal(qury)" title="Edit qury" ></i>
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>
</div>
    
            
   <!--  </div> -->
    <!-- </div> -->
        

      </div>
    </div>
  </div>
</template>

<script>
import ManageBooking from './ManageBooking';
import QueriesService from './service';
import UploadService from '../../lib/UploadService';

export default {
  name: 'bookings',

  created() {
    this.fetchUsers();

    this.$bus.$on('QURY_UPDATE', (updatedUser, isNewUser) => {
      if (isNewUser) {
        this.queries.unshift(updatedUser);
      } else {
        this.queries = this.queries.map(qury => {
          if (qury.docId === updatedUser.docId) {
            return updatedUser;
          }

          return qury;
        });
      }
    });
  },

  components: {
    ManageBooking
  },

  data() {
   const data = [this.queries]
    return {
       isUsersLoading: false,
       searchName: null,
       isAddUpdateUserModalOpen: false,
       files: null,
       isLoading: true,
       queries: [],
       status,
       isBordered: true,
       isStriped: true,
       isNarrowed: false,
       isHoverable: true,
       isFocusable: false,
       hasMobileCards: true,
       isPaginated: true,
       isPaginationSimple: false,
       defaultSortDirection: 'asc',
       currentPage: 1,
       perPage: 10
    };
  },

  methods: {

    fetchUsers() {
      this.isUsersLoading = true;
      this.queries = null;
      QueriesService.all().then(queries => {
        this.queries = queries;
        this.isUsersLoading = false;

      });
    },

    deleteUser(quryToDelete) {
      this.isUsersLoading = true;
    this.$dialog.confirm({
    message: 'Sure to delete qury?',
        onConfirm: () => {
      QueriesService.deleteUser(quryToDelete.docId).then(() => {
        this.queries = this.queries.filter(
          qury => quryToDelete.docId !== qury.docId
        );
        this.isUsersLoading = false;
        this.$toast.open('User deleted successfully');
      });
        }
});
    },

    openModal(qury = null) {
      this.$modal.open({
        parent: this,
        props: {
          propQury: qury,
        },
        component: ManageQury,
        hasModalCard: true
      });
    },

    uploadImage(qury) {
      UploadService(this.files[0], 'queries', qury.docId)
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    }
  }
};
</script>

<style scoped>
.categories-container {
  padding: 0.5rem;
}
.queries-container {
  height: 80vh !important;
  overflow-y: scroll;
}
.qury-image {
  height: 50px;
  margin-left: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 50%;
 
}



</style>



// WEBPACK FOOTER //
// src/pages/bookings/Bookings.vue